export default () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13.3467"
        cy="13.3467"
        r="13.3467"
        transform="matrix(-1 0 0 1 26.998 0.652344)"
        fill="#006299"
      />
      <line
        x1="1"
        y1="-1"
        x2="9.28412"
        y2="-1"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 17.2871 8.08301)"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="15.8729"
        y1="19.915"
        x2="10.0151"
        y2="14.0573"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
